var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7783 2.89111C7.25532 2.89111 2.77832 7.36811 2.77832 12.8911C2.77832 18.4141 7.25532 22.8911 12.7783 22.8911C18.3013 22.8911 22.7783 18.4141 22.7783 12.8911C22.7783 7.36811 18.3013 2.89111 12.7783 2.89111Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04932 19.2371C5.04932 19.2371 7.27832 16.3911 12.7783 16.3911C18.2783 16.3911 20.5083 19.2371 20.5083 19.2371",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7783 12.8911C13.574 12.8911 14.337 12.575 14.8996 12.0124C15.4623 11.4498 15.7783 10.6868 15.7783 9.89111C15.7783 9.09546 15.4623 8.3324 14.8996 7.76979C14.337 7.20718 13.574 6.89111 12.7783 6.89111C11.9827 6.89111 11.2196 7.20718 10.657 7.76979C10.0944 8.3324 9.77832 9.09546 9.77832 9.89111C9.77832 10.6868 10.0944 11.4498 10.657 12.0124C11.2196 12.575 11.9827 12.8911 12.7783 12.8911V12.8911Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.dd9f4bddd809fd134b80b326b22c8da6.svg";
export { ForwardRef as ReactComponent };